import { render, staticRenderFns } from "./ShipMiniIcon.vue?vue&type=template&id=54d9a0bc&"
import script from "./ShipMiniIcon.vue?vue&type=script&lang=js&"
export * from "./ShipMiniIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports